<template>
	<div class="line loadStop">
		<div v-if="length > 1 && stopIndex > 0" class="head">Stop {{ stopIndex }}</div>
		<div class="main">

			<item-info-row
					v-if="item.company"
					:is-item-icon="false"
					text="Company:"
					:value="item.company"
					margin="0"
			></item-info-row>

			<item-info-row
					v-if="item.street"
					:is-item-icon="false"
					text="Address:"
					:value="item.street"
					margin="0"
			></item-info-row>

			<item-info-row
					v-if="item.phone"
					:is-item-icon="false"
					text="Phone:"
					:value="item.phone"
					margin="0"
			></item-info-row>

			<item-info-row
					:is-item-icon="false"
					text="Location:"
					:value="getLocation"
					margin="0"
			></item-info-row>

			<item-info-row
					v-if="item.date_time"
					:is-item-icon="false"
					text="Date and time:"
					:value="formatToUS(item.date_time)"
					margin="0"
			></item-info-row>

			<item-info-row
					v-if="item.app"
					:is-item-icon="false"
					text="App#:"
					:value="item.app"
					margin="0"
			></item-info-row>

		</div>
	</div>
</template>

<script>

import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { formatToUS } from "@/helper/formatToUS";

export default {
	name: "LoadStop",
	methods: { formatToUS },
	components: { ItemInfoRow },
	props: {
		length: Number,
		item: Object,
		index: Number,
	},
	computed: {
		stopIndex() {
			return String(this.index).padStart(2, '0');
		},
		getLocation() {
			 return `${ this.item.loction.city }, ${ this.item.loction.state }, ${ this.item.loction.zip_code }`;
		}
	},
};
</script>

<style scoped lang="scss">
.loadStop {
	.head {
		background: var(--card-bg-opacity);
		padding: 3px;
		color: var(--base-green);
	}

	.main {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

}

</style>
